// @flow strict

import { createContext } from 'react';

export default createContext<?((width: number, x: number) => void)>();
